
import Body from 'commons/card/Body';
import CollapsableCard from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import Toolbar from 'pages/tables/components/Toolbar';
import React, { useState } from 'react';
import * as mapper from '../models/Mapper';
import { Gantt, GanttMonthView, GanttWeekView, GanttYearView, extendDataItem, mapTree, } from '@progress/kendo-react-gantt';
import "./CustomGantt.scss";
import { useEffect } from 'react';
import { filterBy as filterByQuery } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import PropTypes from 'prop-types';

export default function CustomGantt(props) {
  const [data, setData] = useState(mapper.stringify(props.data.data));
  const [dependencies, setDependencies] = useState(Object.keys(mapper.depedency(props.data.data)).length !== 0 ? mapper.depedency(props.data.data) : []);
  const [expandedState, setExpandedState] = React.useState([]);

  let taskModelFields = {
    id: 'id',
    start: "start",
    end: "end",
    title: "title",
    camp_num: 'camp_num',
    camp_dt_deb: 'camp_dt_deb',
    camp_dt_fin: 'camp_dt_fin',
    camp_descr: 'camp_descr',
    percentComplete: 'percentComplete',
    children: 'children',
    isExpanded: "isExpanded"
  };

  let dependencyModelFiels = {
    fromId: "predecessorId",
    toId: "successorId",
    type: "type",
    id: "id"
  };

  let columns = [
    {
      field: taskModelFields.camp_num,
      title: "#",
      sortable: true,
      width: 105,
      expandable: true
    },
    {
      field: taskModelFields.camp_descr,
      title: "Projet",
      sortable: false,
      width: 250
    },
  ];
  const getCampNum = getter(taskModelFields.camp_num);
  const navigateToProject = (dataItem) => {
    props.navigate(props.location.pathname + '/Projets/' + dataItem.camp_seq
    );
  };

  useEffect(() => {
    setData(mapper.stringify(props.data.data));
    setDependencies(Object.keys(mapper.depedency(props.data.data)).length !== 0 ? mapper.depedency(props.data.data) : []);
  }, [props.data.data]);

  useEffect(() => {
    setTaskStyle();
  }, [data]);

  const removeTaskSummary = (row, campDescr) => {
    if (!row.className.includes("k-task-summary"))
      return;

    row.className = "k-task k-task-single";
    row.style.top = '10px';
    let taskCompleteDiv = document.createElement("div");
    taskCompleteDiv.classList.add('k-task-complete');
    taskCompleteDiv.style.width = '0px';
    let taskContentDiv = document.createElement("div");
    taskContentDiv.classList.add("k-task-content");
    taskContentDiv.innerHTML = campDescr;
    row.innerHTML = '';
    row.appendChild(taskCompleteDiv);
    row.appendChild(taskContentDiv);
  };

  const setTaskStyle = () => {
    setTimeout(() => {
      let tasksContent = document.getElementsByClassName("k-task");
      for (var i = 0; i < tasksContent.length; i++) {
        removeTaskSummary(tasksContent[i], data.find(d => d.camp_seq.toString() === tasksContent[i].getAttribute("data-task-id"))?.camp_descr);
        let color = data.find(d => d.camp_seq.toString() === tasksContent[i].getAttribute("data-task-id"))?.color;
        if (!color)
          color = data.flatMap(f => f.children).filter(d => d).find(d => d.camp_seq.toString() === tasksContent[i].getAttribute("data-task-id"))?.color;

        tasksContent[i].style.backgroundColor = color;
        tasksContent[i].style.borderRadius = '25px';
        tasksContent[i].style.color = 'white';
      }
    }, 0);
  };

  const processedData = React.useMemo(() => {
    return mapTree(data, taskModelFields.children, task => extendDataItem(task, taskModelFields.children, {
      [taskModelFields.isExpanded]: expandedState.includes(getCampNum(task))
    }));
  }, [data, expandedState]);

  const onExpandChange = React.useCallback(
    (event) => {
      const campNum = getCampNum(event.dataItem);
      const newExpandedState = event.value
        ? expandedState.filter((currentId) => currentId !== campNum)
        : [...expandedState, campNum];
      setExpandedState(newExpandedState);
      setTaskStyle();
    },
    [expandedState, setExpandedState, data]
  );

  return (
    <>
      <CollapsableCard canCollapse={false} style={{ backgroundColor: 'white', maxWidth: '100%', position: 'absolute', left: '225px', right: '0px' }}>
        <div className="inline">
          <div style={{ marginTop: '12px' }}>
            <Header title={props.title}></Header>
          </div>
          <div className="me-auto"></div>
          <div className='whiteBg'>
            <Toolbar
              showCreateBtn={false}
              gantt={true}
              onSearchChange={(value) => {
                var propsFilters = value.target.value ? [
                  'camp_num',
                  'camp_descr',
                  'camp_seq',
                  'camp_dt_deb',
                  'camp_dt_fin',
                ].map((item) => {
                  return {
                    field: item,
                    operator: 'contains',
                    value: value.target.value,
                    ignoreCase: true,
                  };
                }) : undefined;
                if (propsFilters) {
                  let filteredData = filterByQuery(mapper.stringify(props.data.data), {
                    logic: 'or',
                    filters: propsFilters,
                  });
                  setData(filteredData);
                }
                else
                  setData(mapper.stringify(props.data.data));
              }}></Toolbar>
          </div>
        </div>

        <Body>
          <div>
            <Gantt onViewChange={setTaskStyle} columns={columns} onTaskClick={(e) => navigateToProject(e.dataItem)}
              style={{ width: '100%' }} onRowClick={(e) => navigateToProject(e.dataItem)} onExpandChange={onExpandChange}
              defaultView='month' resizable={true} taskData={processedData}
              dependencyModelFields={dependencyModelFiels} dependencyData={dependencies} rowHeight={50} taskModelFields={taskModelFields}
              selectable={{ mode: 'single', cell: true, enabled: true, drag: true }}>
              <GanttYearView title={"Année"} />
              <GanttMonthView title={"Mois"} />
              <GanttWeekView title={"Semaine"} />
            </Gantt>
          </div>
        </Body>
      </CollapsableCard ></>
  );
}

CustomGantt.propTypes = {
  data: PropTypes.any,
  title: PropTypes.any,
  navigate: PropTypes.any,
  location: PropTypes.any
};
